export interface SearchListsParams {
  searchQuery?: string;
  limit?: number;
}

export const listsKeys = {
  all: ['lists'] as const,

  // List queries
  lists: () => [...listsKeys.all, 'list'] as const,
  search: (params: SearchListsParams) => [...listsKeys.all, 'search', params] as const,

  // List details
  details: () => [...listsKeys.all, 'detail'] as const,
  detail: (urlKey: string) => [...listsKeys.details(), urlKey] as const,

  // Restaurant's lists
  restaurantLists: (restaurantId: number) =>
    [...listsKeys.all, 'restaurant', restaurantId] as const,

  // Trending
  trending: (limit?: number) => [...listsKeys.all, 'trending', { limit }] as const,

  // Tags
  tags: () => [...listsKeys.all, 'tags'] as const,
  byTag: (tagSlug: string) => [...listsKeys.all, 'byTag', tagSlug] as const,

  // Community lists (paginated)
  communityLists: () => [...listsKeys.all, 'communityLists'] as const,
  byTagInfinite: (tagSlug: string) => [...listsKeys.all, 'byTagInfinite', tagSlug] as const,

  // Featured lists (staff-curated, not paginated)
  featuredLists: () => [...listsKeys.all, 'featuredLists'] as const,

  // Activity feed
  activityFeed: () => [...listsKeys.all, 'activityFeed'] as const,

  // User's lists (by user ID)
  byUser: (userId: number) => [...listsKeys.all, 'byUser', userId] as const,
} as const;
